import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={6} height={36} fill="none" {...props}>
        <Path fill="#000" fillRule="evenodd" d="M6 0H0l1 26h4L6 0Zm0 30H0v6h6v-6Z" clipRule="evenodd" />
    </Svg>
);
export default SvgComponent;
